import TextField from "../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import {
  ExcluirFeriasService
} from "../../../services/ExcluirFeriasService";

export default {
  name: "ParametrizarExclusao",

  components: {
    TextField,
    PeriodoField,
    SelectField
  },

  data: () => ({
    form: {},
    militares: [],
    selected: [],


    loading: {
      field: false,
      btn: false
    }
  }),

  beforeMount() {
    this.initializeForm();

  },

  mounted() {

  },

  methods: {
    async pesquisarAbono() {
      const formData = new FormData()
      formData.append("filtro", this.form.pesquisar);

      const response = await ExcluirFeriasService.pegarUsuariosAbono(formData)

      this.militares = response
    },

    prepareForm() {
      const formData = new FormData()

      this.selected.forEach((element, index) => {
        formData.append(`param[${index}][id_sigrh]`, element.id);
        formData.append(`param[${index}][id_ferias]`, element.idFerias);
      });

      this.sendForm (formData);
    },

    async sendForm(postData) {
      this.loading = true;

      const response = await ExcluirFeriasService.excluirFeriasParametizar(postData)

      if (response) {
        this.close();
      }
      this.loading = false;

    },

    initializeForm() {
      this.form = {
        pesquisar: "",
      };
    },
    close() {
      this.$emit("on-close");
    },
  }

};